const schema = localStorage.getItem("schema");
const userDetails = JSON.parse(localStorage.getItem("authUser"));
export const sparePartRequestFormData = () => ({
  inputData: {
    // id: null,
    intake_id: null,
    job_card_no: null,
    scrap_reason_id: null,
    approved_by: userDetails?.id,
    approved_at: new Date().toISOString().replace("T", " ").slice(0, 19),
    remark: null,
    status: "Approved",
    is_active: true,
  },
});

export const createPageData = () => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "scraps",
    schema: schema,

    include: [
      {
        model: "material_intakes",
        as: "intake",
      },
      {
        model: "scrap_reason_masters",
        as: "reason",
      },
      {
        model: "user_masters",
        as: "approved_by_user",
      },
    ],
  };

  const navigatePage = { back: "/scrap-list" };

  const headerName = "Scrap";

  const validationType = "ScrapCreate";
  const createEndpoint = "/updaterelationaldata";
  const updateEndpoint = "/updaterelationaldata  ";

  const getEndpoint = "/getRecords";

  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
  };
};

export const listPageData = () => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "scraps",
    schema: schema,

    include: [
      {
        model: "material_intakes",
        as: "intake",
        include: [
          {
            model: "material_masters",
            as: "material", // <-- must match association alias
          },
        ],
      },
      {
        model: "scrap_reason_masters",
        as: "reason",
      },
      {
        model: "user_masters",
        as: "approved_by_user",
      },
      {
        model: "job_cards",
        as: "job_cards",
      },
    ],
  };

  const searchfields = [
    "intake.intake_no",
    "job_card_no",
    "remark",
    "reason.reason",
    "status",
  ];

  const endpoint = "/getRecords";
  const exportFileName = "scrapData.xlsx";

  return {
    payload,
    endpoint,
    searchfields,
    exportFileName,
  };
};
